import React from "react";

const LinkIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.78874 16.5389C6.53308 16.5389 5.46274 16.0964 4.57774 15.2114C3.69274 14.3266 3.25024 13.2564 3.25024 12.0009C3.25024 10.7454 3.69274 9.67508 4.57774 8.78991C5.46274 7.90458 6.53308 7.46191 7.78874 7.46191H10.808C11.0205 7.46191 11.1986 7.53383 11.3422 7.67766C11.4861 7.8215 11.558 7.99975 11.558 8.21241C11.558 8.42491 11.4861 8.603 11.3422 8.74666C11.1986 8.89016 11.0205 8.96191 10.808 8.96191H7.78749C6.94849 8.96191 6.23258 9.25841 5.63974 9.85141C5.04674 10.4444 4.75024 11.1607 4.75024 12.0004C4.75024 12.8401 5.04674 13.5564 5.63974 14.1494C6.23258 14.7424 6.94849 15.0389 7.78749 15.0389H10.808C11.0205 15.0389 11.1986 15.1108 11.3422 15.2547C11.4861 15.3985 11.558 15.5767 11.558 15.7892C11.558 16.0018 11.4861 16.1799 11.3422 16.3234C11.1986 16.4671 11.0205 16.5389 10.808 16.5389H7.78874ZM9.75024 12.7504C9.53774 12.7504 9.35966 12.6785 9.21599 12.5347C9.07216 12.3908 9.00024 12.2127 9.00024 12.0002C9.00024 11.7875 9.07216 11.6094 9.21599 11.4659C9.35966 11.3222 9.53774 11.2504 9.75024 11.2504H15.7502C15.9627 11.2504 16.1408 11.3223 16.2845 11.4662C16.4283 11.61 16.5002 11.7882 16.5002 12.0007C16.5002 12.2133 16.4283 12.3914 16.2845 12.5349C16.1408 12.6786 15.9627 12.7504 15.7502 12.7504H9.75024ZM14.6925 16.5389C14.48 16.5389 14.3019 16.467 14.1582 16.3232C14.0144 16.1793 13.9425 16.0011 13.9425 15.7884C13.9425 15.5759 14.0144 15.3978 14.1582 15.2542C14.3019 15.1107 14.48 15.0389 14.6925 15.0389H17.713C18.552 15.0389 19.2679 14.7424 19.8607 14.1494C20.4537 13.5564 20.7502 12.8401 20.7502 12.0004C20.7502 11.1607 20.4537 10.4444 19.8607 9.85141C19.2679 9.25841 18.552 8.96191 17.713 8.96191H14.6925C14.48 8.96191 14.3019 8.89 14.1582 8.74616C14.0144 8.60233 13.9425 8.42416 13.9425 8.21166C13.9425 7.999 14.0144 7.82091 14.1582 7.67741C14.3019 7.53375 14.48 7.46191 14.6925 7.46191H17.7117C18.9674 7.46191 20.0377 7.90441 20.9227 8.78941C21.8077 9.67425 22.2502 10.7444 22.2502 11.9999C22.2502 13.2554 21.8077 14.3257 20.9227 15.2109C20.0377 16.0962 18.9674 16.5389 17.7117 16.5389H14.6925Z"
        fill="url(#paint0_linear_3111_9910)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3111_9910"
          x1="12.7502"
          y1="7.46191"
          x2="12.7502"
          y2="16.5389"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40599B" />
          <stop offset="1" stopColor="#223B7D" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default LinkIcon;
